import { useCallback, useEffect, useState } from "react";
import { getCalidadRequisitosLegales } from "../api/requisitos-legales";
import type {
  RequisitoLegalAspecto,
  RequisitoLegalControlModificacion,
  RequisitoLegalRow,
} from "../types/requisitos-legales";

type State = {
  rows: RequisitoLegalRow[];
  controlModificaciones: RequisitoLegalControlModificacion[];
  aspectos: RequisitoLegalAspecto[];
  counts: {
    aspectos: number;
    referencias: number;
    requisitos: number;
    control_modificaciones: number;
  };
};

const initialState: State = {
  rows: [],
  controlModificaciones: [],
  aspectos: [],
  counts: {
    aspectos: 0,
    referencias: 0,
    requisitos: 0,
    control_modificaciones: 0,
  },
};

export function useCalidadRequisitosLegales(enabled = true) {
  const [state, setState] = useState<State>(initialState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    if (!enabled) {
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await getCalidadRequisitosLegales();
      setState({
        rows: response.data,
        controlModificaciones: response.control_modificaciones,
        aspectos: response.aspectos,
        counts: response.meta.counts,
      });
    } catch {
      setError("No se pudieron cargar los requisitos legales.");
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    void load();
  }, [load]);

  return {
    ...state,
    loading,
    error,
    reload: load,
  };
}
